import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import UndoneActionsTable from '../../../containers/UndoneActionsTable';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "80%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const ModalAlert = () => {
  // TODO : change open to true (enabled it for dev)
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button sx={{ color: '#900', fontFamily: "Quicksand", m: 2 }} onClick={handleOpen}>Afficher les actions non terminées</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontFamily: "Oswald", mb: 4 }}>
            Il reste des actions non terminées :
          </Typography>
            <UndoneActionsTable />
        </Box>
      </Modal>
    </div>
  );
};

export default ModalAlert;